var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLinkedinLogo = function SvgLinkedinLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_983_9704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0128 0.9375H2.05898C1.46045 0.9375 0.9375 1.36816 0.9375 1.95967V12.9378C0.9375 13.5325 1.46045 14.0625 2.05898 14.0625H13.0096C13.6113 14.0625 14.0625 13.529 14.0625 12.9378V1.95967C14.066 1.36816 13.6113 0.9375 13.0128 0.9375ZM5.00596 11.8778H3.12568V6.03164H5.00596V11.8778ZM4.13086 5.14277H4.11738C3.51562 5.14277 3.12598 4.69482 3.12598 4.13408C3.12598 3.56309 3.52588 3.12568 4.14111 3.12568C4.75635 3.12568 5.13281 3.55986 5.14629 4.13408C5.146 4.69482 4.75635 5.14277 4.13086 5.14277ZM11.8778 11.8778H9.99756V8.68125C9.99756 7.91543 9.72393 7.39219 9.04365 7.39219C8.52393 7.39219 8.21631 7.74375 8.07949 8.08623C8.02822 8.20928 8.01445 8.37686 8.01445 8.54795V11.8778H6.13418V6.03164H8.01445V6.84521C8.28809 6.45557 8.71553 5.89482 9.71016 5.89482C10.9444 5.89482 11.8781 6.7084 11.8781 8.4624L11.8778 11.8778Z",
    fill: "#3E3E3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_983_9704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedinLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin_logo.05bad6e4.svg";
export { ForwardRef as ReactComponent };